import React from "react";
import { Form } from "antd";
import EcSelect from "@/components/EcSelect";
import OrderStatus from "@/enum/OrderStatus";
import OrderStatusNameMap from "@/map/OrderStatusNameMap";

const ItemStatusesField: React.FC = React.memo(() => {
    const filteredOrderStatuses = Object.keys(OrderStatus).filter(
        (it) => it !== OrderStatus.PENDING_PAYMENT,
    ) as OrderStatus[];

    const getLabel = (status: OrderStatus) => (status === OrderStatus.SUCCESS ? "已完成" : OrderStatusNameMap[status]);

    const data = filteredOrderStatuses.map((status) => ({
        value: status,
        label: getLabel(status),
    }));

    function renderResult(values: OrderStatus[]) {
        if (!values?.length) return "";

        return values.map((status) => getLabel(status)).join();
    }

    return (
        <Form.Item label={<span className="search-field-label">商品状态</span>} name="itemStatuses">
            <EcSelect data={data} placeholder="所有商品状态" multiple renderResult={renderResult} />
        </Form.Item>
    );
});

export default ItemStatusesField;
